export const LG_BREAKPOINT = 992;
export const MD_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1000;
